import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/styles/dashboard-premium.css";
import "@/styles/overview.css";
import { X } from "lucide-react";
import { useUIStore } from "@/app/store/ui.store";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { Button } from "@/components/ui/button";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

export function AppShell() {
  const { mobileNavOpen, setMobileNav } = useUIStore();
  const location = useLocation();
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <div className={`workspace-shell flex h-dvh bg-background premium-dashboard ${location.pathname === "/" ? "overview-studio" : ""}`}>
      <div className="hidden lg:block">
        <Sidebar />
      </div>
      {mobileNavOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 animate-fade-in bg-foreground/40 backdrop-blur-sm"
            onClick={() => setMobileNav(false)}
            aria-hidden="true"
          />
          <div className="relative h-full w-[250px] max-w-[88vw] animate-slide-up">
            <Sidebar onNavigate={() => setMobileNav(false)} forceExpanded />
            <Button
              variant="ghost"
              size="icon"
              className="absolute -right-11 top-2 text-background"
              onClick={() => setMobileNav(false)}
              aria-label="Close navigation"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar />
        <main className="relative min-h-0 min-w-0 flex-1 overflow-y-auto">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-primary/[0.035] to-transparent" />
        <div className="relative mx-auto max-w-[1520px] p-4 sm:p-6 lg:px-8 lg:py-7">
          <ErrorBoundary resetKey={location.pathname}>
            <AnimatePresence mode="wait" initial={false}>
              <motion.div
                key={location.pathname}
                initial={prefersReducedMotion ? false : { opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={prefersReducedMotion ? undefined : { opacity: 0, y: -8 }}
                transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </ErrorBoundary>
        </div>
        </main>
      </div>
    </div>
  );
}
